<template>
  <div>
    <LoadingContainer v-if="loading"/>

    <div v-else>
      <FormPanel
          headline="Create File"
          :errors="errors"
          :company-id="portalCompany.attributes.company_id"
          :content-file-categories="contentFileCategories"
          :initial="{gallery_images: []}"
          @submit="submit"
      />
    </div>
  </div>
</template>

<script>
import http from '@/http'
import notify from '@/notify'
import FormPanel from '../../../../../../../../components/Administration/ContentFiles/Panels/Form'
import LoadingContainer from '../../../../../../../../components/Layout/LoadingContainer'

export default {
  components: {FormPanel, LoadingContainer},

  props: {
    portal: {
      required: true
    },

    portalCompanyId: {
      required: true
    }
  },

  data() {
    return {
      portalCompany: null,
      contentFileCategories: null,

      loading: true,

      errors: {}
    }
  },

  mounted() {
    this.load()
  },

  methods: {
    load() {
      Promise.all([
        http.get('/api/v2/portal-companies/' + this.portalCompanyId),
        http.get('/api/v2/content-file-categories', {'filter[portal_id]': this.portal.id})
      ]).then(responses => {
        this.portalCompany = responses[0].data.data

        this.contentFileCategories = responses[1].data.data

        this.loading = false

      })
    },

    submit(data) {
      const formData = new FormData;

      formData.append('portal_company_id', this.portalCompanyId)

      http.post('/api/v2/content-files', Object.entries(data).reduce((formData, entry) => {
        formData.append(entry[0], entry[1])

        return formData
      }, formData))
          .then(() => {
            notify.success('The content file was saved')

            this.$router.push('/portals/' + this.portal.id + '/content/files')
          })
          .catch(error => {
            if (error.response.status === 422) {
              this.errors = error.response.data.errors
            }

            throw error
          })
    }
  }
}
</script>
